import { render, staticRenderFns } from "./ReportSummary.vue?vue&type=template&id=7a84d456&scoped=true"
import script from "./ReportSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportSummary.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ReportSummary.vue?vue&type=style&index=0&id=7a84d456&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a84d456",
  null
  
)

export default component.exports